import React from 'react';
import {Empty} from 'antd';
import {getFileName, getFileViewPreviewUrl, getObsKey} from '../../utils/filePreview';
import './index.scss';

export function FilePreview({file, url}: { file: any, url?: string }) {
  const obsKey = getObsKey(file);
  const name = getFileName(file);

  if (!url) {
    return (
      <div className="drive-file-preview">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="暂无预览地址"
        />
      </div>
    );
  }

  return (
    <div className="drive-file-preview">
      <iframe src={getFileViewPreviewUrl(obsKey, name)} title={name} className="drive-file-preview__frame"/>
    </div>
  );
}